import { IconButton, Input, InputAdornment } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CropFreeIcon from '@material-ui/icons/CropFree';
import SearchIcon from '@material-ui/icons/Search';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { setMaterialFilterKey, setSelection } from '../../store/actions';
import SelectDialog from '../../components/SelectDialog';
import MaterialTable from './material';
import SelectedChip from './selected';

const useStyles = makeStyles((theme) => ({
  root: {
    color: 'white',
    padding: '2px',
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
    width: '97%'
  },
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  }
}));


function SelectMaterial(props) {
  const classes = useStyles();
  const [openBarkod, setOpenBarkod] = useState(false);

  return (
    <SelectDialog
      open={props.open}
      title={props.defect + ' Hizmeti ' + props.title}
      onClose={props.onClose}
      onEntering={() => props.setMaterialFilterKey("")}
      actions={true}
      setGosterimAdet={props.setGosterimAdet}
      GosterimAdet={props.GosterimAdet}
      SearchField={
        <div className={classes.fields}>
           <IconButton color="primary" aria-label="settings" onClick={() => setOpenBarkod(true)}>
            <CropFreeIcon />
          </IconButton>
          <Input
            onChange={(event) => props.setMaterialFilterKey(event.target.value)}
            value={props.materials.filterKey}
            endAdornment={<InputAdornment position="end">
              <IconButton
                edge="end">
                <SearchIcon />
              </IconButton>
            </InputAdornment>}
            aria-describedby="standard-weight-helper-text"
            placeholder="Malzeme kodu ya da adını giriniz..."
          />
        </div>
      }
      SelectedItems={<SelectedChip defect={props.defect} />}
    >
      <MaterialTable defect={props.defect} openBarkod={openBarkod} setOpenBarkod={setOpenBarkod} GosterimAdet={props.GosterimAdet} />
    </SelectDialog>
  );
}

const mapStateToProps = (state) => ({
  defects: state.defectReducer,
  materials: state.materialReducer,
});


const mapDispatchToProps = {
  setSelection: setSelection,
  setMaterialFilterKey: setMaterialFilterKey,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectMaterial)
